// extracted by mini-css-extract-plugin
export default {"modal":"full-screen-modal_modal__soSnr","active":"full-screen-modal_active__AwBwD","hint":"full-screen-modal_hint__dBcZk"};